import { render } from "./motors-usage.vue?vue&type=template&id=153d0032"
import script from "./motors-usage.vue?vue&type=script&lang=js"
export * from "./motors-usage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__